import { Pipe, PipeTransform } from '@angular/core';
import { ReviewTargetModel } from '@models/reviewTarget.model';
import { ReviewTargetSource } from '@enums/reviewTargetSource.enum';

@Pipe({
  name: 'isIntegratedWithGmb'
})
export class IsIntegratedWithGmbPipe implements PipeTransform {

  transform(reviewTarget: ReviewTargetModel): boolean {
    return !!reviewTarget.source && reviewTarget.source.includes(ReviewTargetSource.googleMyBusiness)
  }

}
